import {Injectable} from '@angular/core';
import {IWithSpecs, SpecLineModel} from "../../properties/models/spec-line.model";
import {CONSTANTS, FileLinkModel, LeModalService, PropertiesQuery, PropertyQuery} from "common-shared";
import {JsonEditorModalComponent} from "../json-editor-modal/json-editor-modal.component";
import {FileLinkEditModalComponent} from "./file-link-edit-modal/file-link-edit-modal.component";
import {Observable} from "rxjs";
import {HtmlEditorModalComponent} from "../html-editor-modal/html-editor-modal.component";

@Injectable({
  providedIn: 'root'
})
export class SpecModelHandlingService {
  constructor(protected propertiesQuery: PropertiesQuery, protected leModalService: LeModalService) {
  }

  editSpec(context: IWithSpecs, line: SpecLineModel) {
    let observable: Observable<any>;
    this.propertiesQuery.selectEntity(line.PropertyId).subscribe(property => {
      if (property.TypeClv === CONSTANTS.PropertyType.Json) {
        observable = this.editJsonSpec(property, line, context);
      }
      if (property.TypeClv === CONSTANTS.PropertyType.FileLink) {
        observable = this.editFileLinkSpec(property, line)
      }
      if (property.TypeClv === CONSTANTS.PropertyType.Html) {
        observable = this.editHtmlSpec(property, line, context);
      }
      observable?.subscribe(value => {
        if (line.Value !== value.data) {
          line.Value = value.data;
        }
        if (context && !context.Specs.find(spec => spec.Id == line.Id)) {
          context.Specs = [...context.Specs, line];
        }
      });
    });
  }

  private editJsonSpec(property: PropertyQuery, line: SpecLineModel, context: IWithSpecs) {
    return this.leModalService.show(JsonEditorModalComponent, {initialState: {title: property.Code, jsonContent: line.Value || '{}'}, class: 'modal-lg'}).onHide$
  }

  private editHtmlSpec(property: PropertyQuery, line: SpecLineModel, context: IWithSpecs) {
    return this.leModalService.show(HtmlEditorModalComponent, {initialState: {title: property.Code, htmlContent: line.Value || ''}, class: 'modal-lg'}).onHide$
  }

  editFileLinkSpec(property: PropertyQuery, line: SpecLineModel) {
    return this.leModalService.show(FileLinkEditModalComponent, {initialState: {title: property.Code, spec: line}, class: 'modal-md'}).onHide$;
  }

  editMultiFileLinkSpec(property: PropertyQuery, fileLink: FileLinkModel) {
    return this.leModalService.show(FileLinkEditModalComponent, {initialState: {title: property.Code, fileLink: fileLink}, class: 'modal-md'}).onHide$;
  }
}
